module.exports = __webpack_public_path__ + "img/icon_map_62_on_110.9a9b3371.png";